import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ScheduleDefaults } from "src/app/models/ScheduleDefaults";
import { ScheduleParameters } from "src/app/models/ScheduleParameters";
import { ScheduleDataService } from "../../services/schedule-data.service";
import { ListDataService } from "../../services/list-data.service";
import { catchError, of, switchMap, tap } from "rxjs";
import { ListItem } from "src/app/models/ListItem";
import { LoadingService } from "../services/loading.service";
import { StorageService } from "../services/storage.service";
import { SearchParamsModel } from "../models/search-params-model";
import { ScheduleItem } from "src/app/models/ScheduleItem";
import { FormStatus, LoadBankType, LocationType } from "src/app/models/Enums";
import { ScheduleLoads } from "src/app/models/ScheduleLoads";
import { LoadData } from "../models/LoadData";
import { LoadBankApplyParameters } from "src/app/models/LoadBankApplyParameters";
import { DeleteParameters } from "src/app/models/DeleteParameters";
import { DeleteComponent } from "src/app/delete-confirm/delete-confirm.component";
import { LoadBankApplyLoads } from "src/app/models/LoadBankApplyLoads";
import { AlertParameters } from "src/app/models/AlertParameters";
import { DispatchItem } from "../../models/DispatchItem";
import { DispatchParameters } from "src/app/models/DispatchParameters";
import { UserDataService } from "../../services/user-data.service";

@Component({
    selector: "app-schedule-mobile",
    templateUrl: "schedule-mobile.component.html",
    styleUrls: ["schedule-mobile.component.css"],
    standalone: false
})
export class ScheduleMobileComponent implements OnInit {
  searchFilterData: ScheduleParameters = new ScheduleParameters();
  loadsData: LoadData[] = [];
  showOrigin: boolean = false;
  showDestination: boolean = false;
  showAdditionalFilter: boolean = false;
  originsResult: ScheduleItem[] = [];
  destinationsResult: ScheduleItem[] = [];
  form: FormGroup;
  storedDataFromLS: SearchParamsModel;
  locList: ListItem[] = [];
  showCustomDatePicker: boolean = false;
  dispatchForm: DispatchParameters = new DispatchParameters();
  errorMessage: string = "";
  scheduleForm: ScheduleDefaults = new ScheduleDefaults();
  customers: ListItem[] = [];
  truckers: ListItem[] = [];
  origins: ListItem[] = [];
  destinations: ListItem[] = [];
  commodities: ListItem[] = [];
  searchedForIsDispatch: boolean = false;
  dispatchList: DispatchItem[] = [];
  sendDispatchRefresh: boolean = false;
  message: string = "";
  showMoreIcons: boolean = false;
  isInitialLoad: boolean = true;
  hasOpenedIcon: boolean = false;
  loadBankApplyFormIdSc: string = "loadBankApplyModalSc";
  deleteFormId: string = "deleteModal";
  loadBankApplyParameters: LoadBankApplyParameters = new LoadBankApplyParameters();
  showLoadBankApply: boolean = false;
  @ViewChild('loadsModalBtn') loadButton!: ElementRef<HTMLButtonElement>;
  globalDispatchId = null;
  isLoadApplyFromPopup = false;
  formStatus: FormStatus;
  deleteItemParams: DeleteParameters;
  @ViewChild('deleteConfirmChildComponent') deleteConfirmChildComponent!: DeleteComponent;
  loadBankType: LoadBankType;
  sendDispatchId: number = null;
  dispatchFormId: string = 'dispatchModal';
  confirmDispatchFormId: string = "confirmDispatchModal-LoadsStatusModal";
  alertTruckerFilterModalIdSc: string = "alertTruckerFilterModalId";
  sendAlertTruckerDispatchId: number = null;
  alertTruckerForm: AlertParameters = new AlertParameters();
  planPeriods: ListItem[];
  isBackClicked: boolean = false;

  constructor(
    private router: Router,
    private _listDataService: ListDataService,
    private formBuilder: FormBuilder,
    private _storageService: StorageService,
    private _loadingService: LoadingService,
    private _scheduleDataService: ScheduleDataService,
    public _scheduleData: ScheduleDataService,
    private cdr: ChangeDetectorRef,
    private _userDataService: UserDataService
  ) {
    const nav = this.router.getCurrentNavigation();
    this.isBackClicked = nav?.extras.state?.["isBackClicked"] ?? false

  }



  ngOnInit(): void {
    setTimeout(() => {
      this.message = "";
    }, 3000)
    this.loadBankApplyParameters.contractIds = [];
    this.initialize();
    this.getLOCCodes();
  }

  private initialize() {
    this.storedDataFromLS = this._storageService.getData<SearchParamsModel>('advancedSearchFormParams') ?? new SearchParamsModel();

    this.initializeForm(this.storedDataFromLS);

  }

  private initializeForm(storedDataFromLS: SearchParamsModel): void {
    this.form = this.formBuilder.group({
      locCode: [storedDataFromLS.locCode || "", Validators.required],
      mobilePlanPeriod: [storedDataFromLS.selectedPeriodRange || "WeekCurrent", Validators.required],
      locationType: [storedDataFromLS.locationType == 0  ? LocationType.Origin : LocationType.Destination, Validators.required],
      customerId: [storedDataFromLS.customer || 0],
      originId: [storedDataFromLS.origin || 0],
      destinationId: [storedDataFromLS.destination || 0],
      truckerId: [storedDataFromLS.trucker || 0],
      commodityCode: [storedDataFromLS.commodity || ""],
      searchFor: [storedDataFromLS.selectedSearchFor || "Schedules"],
      customPeriodStartDate: [storedDataFromLS?.periodStartDate],
      customPeriodEndDate: [storedDataFromLS?.periodEndDate]
    });

    this.showCustomDatePicker = storedDataFromLS.selectedPeriodRange === "Custom";
  }

  search(event: string = "") {
    this.searchFilterData.locCode = this.form.get('locCode').value;
    this.searchFilterData.selectedPeriodRange = this.form.get('mobilePlanPeriod').value;
    this.searchFilterData.locationType = +this.form.get('locationType').value;
    if (this.searchFilterData.locCode && this.searchFilterData.selectedPeriodRange && (this.searchFilterData.locationType == 1 || this.searchFilterData.locationType == 0)) {
      if (event == "") {
        this.searchFilterData.periodStartDate = this.form.get('customPeriodStartDate').value;
        this.searchFilterData.periodEndDate = this.form.get('customPeriodEndDate').value;
        this.searchFilterData.customerId = this.form.get('customerId').value;
        this.searchFilterData.destinationId == this.form.get('destinationId').value;
        this.searchFilterData.originId = this.form.get('originId').value;
        this.searchFilterData.truckerId = this.form.get('truckerId').value;
        this.searchFilterData.commodityCode = this.form.get('commodityCode').value;
        this.searchFilterData.searchFor = this.searchedForIsDispatch ? "Dispatches" : "Schedules";
        this._storageService.storeData<SearchParamsModel>('advancedSearchFormParams', {
          periodStartDate: this.searchFilterData.periodStartDate,
          periodEndDate: this.searchFilterData.periodEndDate,
          locCode: this.searchFilterData.locCode,
          locCodeValue: this.locList.find(c => c.value === this.searchFilterData.locCode)?.text ?? "",
          selectedPeriodRange: this.searchFilterData.selectedPeriodRange,
          locationType: this.searchFilterData.locationType,
          commodity: this.searchFilterData.commodityCode,
          customer: this.searchFilterData.customerId?.toString(),
          origin: this.searchFilterData.originId?.toString(),
          destination: this.searchFilterData.destinationId?.toString(),
          trucker: this.searchFilterData.truckerId?.toString(),
          locationId: this.searchFilterData.originId > 0 ? this.searchFilterData.originId?.toString() : this.searchFilterData.destinationId?.toString(),
          selectedSearchFor: this.searchFilterData.searchFor,
          customerName: this.customers.find(x => x.id == this.searchFilterData.customerId)?.text,
          destinationName: this.destinations.find(x => x.id == this.searchFilterData.destinationId)?.text,
          originName: this.origins.find(x => x.id == this.searchFilterData.originId)?.text,
          truckerName: this.truckers.find(x => x.id == this.searchFilterData.truckerId)?.text,
        });
        this.storedDataFromLS = this._storageService.getData<SearchParamsModel>('advancedSearchFormParams');
      }
      if (this.searchFilterData.searchFor == "Schedules") {
        this.loadOriginOrDestinationData(this.searchFilterData.locationType == LocationType.Destination);
      }
      else {
        this.getDispatches(this.searchFilterData);
      }
    }
  }

  redirectToDispatch(dispatchId: number, loadbreakout: boolean): void {
    this.router.navigate([loadbreakout ? "/dispatch-detail-day" : "/dispatch-detail-noday", dispatchId]);
  }

  selectOne(): void {
    const selectedTruckers = this.getCheckedTruckers();

    this._storageService.storeData("selectedTruckersInfo", { truckerIds: JSON.stringify(selectedTruckers) });
  }

  getCheckedTruckers(): string[] {
    return Array.from(document.querySelectorAll<HTMLInputElement>('input[type="checkbox"]:checked'))
      .map(checkbox => checkbox.value)
      .filter(value => !isNaN(Number(value)) && value.trim() !== "" && value !== "on");
  }

  getDispatches(searchFilterData) {
    this._scheduleData.getDispatchesWithFilters(searchFilterData).subscribe({
      next: (data) => {
        this.hasOpenedIcon = false;
        this.dispatchList = data;
      },
      error: (err) => {
        this.errorMessage = err;
      },
    });
  }

  toggleChanged(event: any) {
    this.searchedForIsDispatch = event.target.checked;
    this.searchFilterData.searchFor = this.searchedForIsDispatch ? "Dispatches" : "Schedules";
    this.getAllDropDownValues();
    this.search();
    this.hasOpenedIcon = false;
  }

  getLOCCodes() {
    this._loadingService.runWithLoader(this._listDataService.getListItems("loc"))
      .pipe(
        tap((data: ListItem[]) => this.locList = data),
        switchMap(() => {

          if (this.storedDataFromLS.locCode && this.storedDataFromLS.selectedPeriodRange) {
            this.form.get("locCode").setValue(this.storedDataFromLS.locCode);

            this.getPlanPeriods();
            this.selectPeriodDates({ value: this.storedDataFromLS.selectedPeriodRange }, "load");
            if (this.storedDataFromLS.locCode != "") {
              this.search();
            }
            return of(null);
          } else {
            return this._userDataService.getUserSettings().pipe(
              tap(data => {
                this.form.get("locCode").setValue(data.defaultLocCode);
                this.getPlanPeriods();
              })
            );
          }
        }),
        catchError(err => {
          this.errorMessage = err;
          return of(null);
        })
      )
      .subscribe();
  }

  getPeriodDatesAndsearch() {
    this._loadingService.runWithLoader(this._listDataService.getPeriodDates(this.form.value.mobilePlanPeriod))
      .subscribe({
        next: (data) => {
          this.form.patchValue({
            customPeriodStartDate: data.startDate,
            customPeriodEndDate: data.endDate
          });
          this.searchFilterData.periodStartDate = data.startDate;
          this.searchFilterData.periodEndDate = data.endDate;

          this.search();
        },
        error: (err) => this.errorMessage = err,
      });
  }

  resetSearchParameters() {
    this._storageService.clearData("advancedSearchFormParams");
    this.resetFormFields("change");
    this.getPlanPeriods();
    this.isBackClicked = false;
  }


  getPlanPeriods(): void {
    if (this.form.value.locCode.length > 0) {
      this._listDataService.getPlanPeriods(this.form.value.locCode).subscribe({
        next: data => {
          this.planPeriods = data;
          if (this.planPeriods.length > 0) {
            if (!this.isBackClicked) {
              this.form.get('mobilePlanPeriod').setValue(this.planPeriods[0].value);
              this.searchFilterData.selectedPeriodRange = this.planPeriods[0].value;
            }
            else {
              this.searchFilterData.selectedPeriodRange = this.storedDataFromLS.selectedPeriodRange;
            }
            if (this.form.value.mobilePlanPeriod != "Custom") {

              this.getPeriodDatesAndsearch();
            }
          }
        },
        error: err => this.errorMessage = err
      });
    }
  }

  restrictNegativeValue(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key === '-' || keyboardEvent.key == 'e') {
      event.preventDefault();
      return;
    }
    const loadCount = (event.target as HTMLInputElement).value;
    if (+loadCount < 0) {
      (event.target as HTMLInputElement).value = (event.target as HTMLInputElement).value;
    }
  }

  updateScheduleLoad(schedule: ScheduleItem, event: FocusEvent) {
    const loadCount = (event.target as HTMLInputElement).value;
    if (+loadCount >= 0) {
      let scheduleLoads = new ScheduleLoads();
      scheduleLoads.scheduleId = schedule.scheduleId;
      scheduleLoads.loads = +loadCount;
      this._scheduleDataService.saveScheduleLoads(scheduleLoads).subscribe({
        next: data => {
          schedule.balanceLoads = +loadCount - schedule.dispatchedLoads;
        },
        error: err => this.errorMessage = err
      });
    }
    else {
      (event.target as HTMLInputElement).value = (event.target as HTMLInputElement).value;
    }
  }

  selectPeriodDates(keys, event: string = "change"): void {
    this.showCustomDatePicker = keys.value === "Custom";
    this.searchFilterData.locationType = +this.form.get('locationType').value;
    if (!this.showCustomDatePicker) {
      this._loadingService.runWithLoader(this._listDataService.getPeriodDates(this.form.value.mobilePlanPeriod))
        .subscribe({
          next: (data) => {
            this.form.patchValue({
              customPeriodStartDate: data.startDate,
              customPeriodEndDate: data.endDate
            });
            this.searchFilterData.periodStartDate = data.startDate;
            this.searchFilterData.periodEndDate = data.endDate;
            this.searchFilterData.selectedPeriodRange = keys.value;

            this.updateScheduleParamsForNonCustom(data, event);
            this.getAllDropDownValues();
            this.search();
          },
          error: (err) => this.errorMessage = err,
        });
    }
    else {
      this.getAllDropDownValues();
    }
  }

  changeLocationType(keys) {
    this.searchFilterData.locationType = parseInt(keys.value)
    this.searchFilterData.customerId = 0;
    this.searchFilterData.originId = 0;
    this.searchFilterData.destinationId = 0;
    this.searchFilterData.truckerId = 0;
    this.searchFilterData.commodityCode = "";
    this.loadDropdowns(keys, keys.value);
  }

  private updateScheduleParamsForNonCustom(data: any, event: string): void {
    if (this.form.value.mobilePlanPeriod !== "Custom") {
      this.showCustomDatePicker = false;
      this.form.controls["customPeriodStartDate"].setValue(data.startDate);
      this.form.controls["customPeriodEndDate"].setValue(data.endDate);
    }
    if (event === "change") {
      this.resetFormFields("change");
    }
  }

  getDay(pickupDate: string): string {
    const date = new Date(pickupDate);
    return date.toLocaleString('en-US', { weekday: 'short' });
  }

  resetFormFields(event: string): void {
    this.form.controls["customerId"].setValue("0");
    this.form.controls["originId"].setValue("0");
    this.form.controls["destinationId"].setValue("0");
    this.form.controls["commodityCode"].setValue("");
    this.form.controls["truckerId"].setValue("0");

    this.searchFilterData.locationType = 1;
    this.searchFilterData.customerId = 0;
    this.searchFilterData.destinationId = 0;
    this.searchFilterData.originId = 0;
    this.searchFilterData.commodityCode = "";
    this.searchFilterData.truckerId = 0;
    if (event == "changeAll") {
      this.searchFilterData.locationType = this.form.controls["locationType"].value;
      const _storedDataFromLS = new SearchParamsModel();
      _storedDataFromLS.locCode = this.storedDataFromLS.locCode;
      _storedDataFromLS.periodEndDate = this.storedDataFromLS.periodEndDate;
      _storedDataFromLS.periodStartDate = this.storedDataFromLS.periodStartDate;
      _storedDataFromLS.selectedPeriodRange = this.storedDataFromLS.selectedPeriodRange;
      _storedDataFromLS.selectedSearchFor = this.storedDataFromLS.selectedSearchFor;
      _storedDataFromLS.locationType = +this.form.controls["locationType"].value;


      this.initializeForm(_storedDataFromLS);
      this.getAllDropDownValues();
      this.search("reset");
      this._storageService.updateData<SearchParamsModel>('advancedSearchFormParams', {
        commodity: "",
        customer: "",
        origin: "",
        destination: "",
        trucker: "",
        locationId: this.searchFilterData.originId > 0 ? this.searchFilterData.originId?.toString() : this.searchFilterData.destinationId?.toString(),
        // selectedSearchFor: this.searchFilterData.searchFor ? "Dispatches" : "Schedules",
        selectedSearchFor: "",
        customerName: "",
        destinationName: "",
        originName: "",
        truckerName: "",
      });
      this.storedDataFromLS = this._storageService.getData<SearchParamsModel>('advancedSearchFormParams');
    }
  }

  loadOriginOrDestinationData(isOrigin: boolean) {
    this._loadingService.runWithLoader(this._scheduleDataService.getSchedulesWithFilters(this.searchFilterData))
      .subscribe({
        next: (data) => {
          if (data) {
            this.hasOpenedIcon = false;
            this.showOrigin = isOrigin;
            this.showDestination = !isOrigin;
            if (isOrigin) {
              this.originsResult = data;
            } else {
              this.destinationsResult = data;
            }
          }
        },
        error: (err) => this.errorMessage = err,
      });
  }

  editDispatch(scheduleId: number, dispatchId: number) {
    let parms = new DispatchParameters();
    parms.locCode = this.form.value.locCode;
    parms.scheduleId = scheduleId;
    parms.dispatchId = dispatchId;
    this.dispatchForm = parms;
  }

  openDispatch(id: number) {
    this.router.navigate(["/view-dispatch", id]);
  }

  manualScheduleClick() {
    this.scheduleForm = {
      scheduleId: 0,
      locationType: +this.form.controls["locationType"].value,
      locCode: this.searchFilterData.locCode,
      periodStartDate: this.searchFilterData.periodStartDate,
      periodEndDate: this.searchFilterData.periodEndDate,
      commodityCode: this.searchFilterData.commodityCode
    };
  }

  scheduleComplete(num: number) {
    if (num > 0) {
      this.message = "1 new schedule has been created.";
      setTimeout(() => {
        this.message = "";
      }, 3000)
     //this.initialize();
      this.search();
    }
  }

  loadDropdowns(keys, type: string): void {
    const locCode = this.form.get('locCode').value;
    const mobilePlanPeriod = this.form.get('mobilePlanPeriod').value;
    const locationType = +this.form.get('locationType').value;

    if (locCode && mobilePlanPeriod && locationType > -1) {
      switch (type) {
        case "customer":
          this.searchFilterData.customerId = keys.value
          break;
        case "origin":
          this.searchFilterData.originId = keys.value;
          this.searchFilterData.locationId = keys.value;
          break;
        case "destination":
          this.searchFilterData.destinationId = keys.value;
          this.searchFilterData.locationId = keys.value;
          break;
        case "trucker":
          this.searchFilterData.truckerId = keys.value;
          break;
        case "commodity":
          this.searchFilterData.commodityCode = keys.value;
          break;
      }

      this.getAllDropDownValues();
      this.search();
    }
  }


  private getAllDropDownValues() {
    const searchFilterParms = { ...this.searchFilterData };
    this._loadingService.runWithLoader(this._scheduleDataService.getMobileFilterLists(searchFilterParms))
      .subscribe({
        next: (data) => {
          this.hasOpenedIcon = false;
          this.commodities = data.commodity;
          this.customers = data.customers;
          this.destinations = data.destinations;
          this.truckers = data.truckers;
          this.origins = data.origins;
        },
        error: (err) => (this.errorMessage = err),
      });
  }

  trackByNumberValue(index: number, item: ListItem): number {
    return item.id;
  }

  trackByStringValue(index: number, item: ListItem): string {
    return item.value;
  }

  setSelectedLoadItem(dispatchId: number) {
    this.isLoadApplyFromPopup = true;
    this._scheduleDataService.getDispatchLoadItems(dispatchId).subscribe({
      next: (data) => {
        this.loadsData = [];
        this.loadsData = data;
        this.cdr.detectChanges();
      },
      error: (err) => (this.errorMessage = err),
    });
  }

  customDates(keys, type) {
    if (type === "start") {
      this.searchFilterData.periodStartDate = keys.value;
    }
    if (type === "end") {
      this.searchFilterData.periodEndDate = keys.value;
    }
    this.searchFilterData.selectedPeriodRange = "Custom";

    if (this.searchFilterData.periodStartDate && this.searchFilterData.periodEndDate) {
      this.form.get('originId').setValue(0);
      this.form.get('customerId').setValue(0);
      this.form.get('destinationId').setValue(0);
      this.form.get('truckerId').setValue(0);
      this.form.get('commodityCode').setValue("");
      this.searchFilterData.commodityCode = "";
      this.searchFilterData.truckerId = 0
      this.searchFilterData.destinationId = 0;
      this.searchFilterData.originId = 0;
      this.searchFilterData.locationId = 0;
      this.searchFilterData.customerId = 0;
      this.loadDropdowns(keys, type);
    }
  }

  setSearchFor(keys) {
    this.searchFilterData.searchFor = keys.value;
  }

  toggleIcons(item: any) {
    this.isInitialLoad = false;
    this.hasOpenedIcon = !item.showMoreIcons;
    this.dispatchList.forEach((data: any) => {
      if (data !== item) data.showMoreIcons = false;
    });
    item.showMoreIcons = !item.showMoreIcons;
  }

  isShowMoreIconsEnabledInAnyDispatch(): boolean {
    return this.dispatchList.filter(x => x.showMoreIcons === true)?.length == 0 || this.isInitialLoad;
  }

  reloadDispatchCount(dispatchId: number) {
    const dispatch = this.dispatchList.find(d => d.dispatchId === dispatchId);

    if (dispatch) {
      dispatch.numberOfLoads = Math.max(0, dispatch.numberOfLoads - 1);
    }
  }

  loadLoads(event: any) {
    this.globalDispatchId = event;
    this.loadButton.nativeElement.click();
  }

  openLoadBank(loadBankType: LoadBankType, dispatch) {
    let parameters = new LoadBankApplyParameters();
    parameters.parentModal = this.loadBankApplyFormIdSc;
    parameters.locCode = this.storedDataFromLS.locCode;
    parameters.loadBankType = loadBankType;
    parameters.commodityCode = dispatch.commodityCode;
    parameters.dispatchId = dispatch.dispatchId;
    parameters.contractIds = [];
    this.loadBankApplyParameters = parameters;
    this.loadBankType = loadBankType;
    return false;
  }

  deleteItem(status: boolean, deleteParameters: DeleteParameters) {
    if (status) {
      this.formStatus = FormStatus.Deleting;
      this._scheduleDataService.deleteDispatch(deleteParameters.dispatchId).subscribe({
        next: data => {
          this.deleteConfirmChildComponent.close();
          this.dispatchList = this.dispatchList.filter(x => x.dispatchId != deleteParameters.dispatchId);
          this.formStatus = FormStatus.Normal;
          this.hasOpenedIcon = false;
        },
        error: err => this.errorMessage = err
      });
    }
  }

  deleteDispatch(dispatchId: number, truckerName: string) {
    let parms = new DeleteParameters();
    parms.dispatchId = dispatchId;
    parms.title = `Are you sure you want to delete the dispatch ${truckerName}?`;
    this.deleteItemParams = parms;
    return false;
  }

  loadBankApplyComplete(event: { dispatchId: number, loadBankApplyLoads: LoadBankApplyLoads }) {
    const dispatchId = event.dispatchId;
    const loadBankIds = event.loadBankApplyLoads.loadBankIds;
    this._scheduleDataService.updateLoadBankApply(dispatchId, loadBankIds, this.loadBankType == LoadBankType.Unload).subscribe({
      next: data => {

      },
      error: err => this.errorMessage = err
    });
  }

  sendComplete(event: number[]) {
    if (event.length > 0) {
      setTimeout(() => {
        this.search();
      }, 3000);
    }

  }


  dispatchSaveComplete(dispatchId: number): void {
    this.message = "Dispatch has been updated.";
    setTimeout(() => {
      this.message = "";
    }, 3000);
    this.search();
  }

  sendDispatch(dispatchId: number) {
    this.sendDispatchId = dispatchId;
    this.sendDispatchRefresh = !this.sendDispatchRefresh;
  }

  sendAlertTruckerDispatch(dispatch: any) {
    this.sendAlertTruckerDispatchId = dispatch.dispatchId;
    let parms = new AlertParameters();
    parms.scheduleId = dispatch.scheduleId;
    parms.dispatchId = dispatch.dispatchId;
    parms.truckerId = dispatch.truckerId;
    parms.periodStartDate = this.storedDataFromLS.periodStartDate;
    parms.periodEndDate = this.storedDataFromLS.periodEndDate;
    parms.selectedLocCodeInFilter = this.storedDataFromLS.locCode;
    parms.isRequestFromSendTextAlertForm = false;
    parms.locationType = this.storedDataFromLS.locationType;
    parms.locCode = this.storedDataFromLS.locCode;
    this.alertTruckerForm = parms;
  }

}
